import * as Sentry from '@sentry/browser';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV
  });
}

export default Sentry;



// WEBPACK FOOTER //
// ./src/utils/SentryBugReporting.js